<!-- Grid — the primary screen. The red car on the grid, five rivals ahead,
     and one thing to do: start the lap. -->
<template>
  <IonPage>
    <AppHeader :title="COPY.title" />

    <IonContent :fullscreen="true">
      <AppLargeTitle :title="COPY.title" />
      <div class="ion-padding grid-body">
        <GridScene />

        <p class="grid-lede">{{ COPY.lede }}</p>

        <ActionButton :label="COPY.start" kind="primary" data-cta="start-btn" @click="startLap" />

        <SurfaceCard v-if="storeError" :title="COPY.errorTitle" :body="COPY.errorBody" />

        <div v-if="best" class="grid-stats">
          <StatTile :label="COPY.bestLabel" :value="formatLapTime(best.timeMs)" />
          <StatTile :label="COPY.winsLabel" :value="wins" />
        </div>
        <SurfaceCard v-else-if="!loading" :title="COPY.emptyTitle" :body="COPY.emptyBody" />

        <ActionButton :label="COPY.garage" kind="secondary" data-cta="garage-btn" @click="openGarage" />
      </div>
    </IonContent>
  </IonPage>
</template>

<script setup>
import { ref, computed } from 'vue';
import { IonPage, IonContent } from '@ionic/vue';
import { useRouter } from 'vue-router';
import { AppHeader, AppLargeTitle, ActionButton, StatTile, SurfaceCard } from '../core/ui/index.js';
import GridScene from '../components/GridScene.vue';
import { lapsReady, storeError } from '../store.js';
import { bestLap, wins } from '../game/results.js';
import { formatLapTime } from '../game/race.js';

const COPY = {
  title: 'Grid',
  lede: 'You are on the grid at Marina Bay in the red Lamborghini Huracan, with five rivals ahead. Wait for the lights to go out.',
  start: 'Start lap',
  garage: 'Open garage',
  bestLabel: 'Best lap',
  winsLabel: 'Wins',
  emptyTitle: 'No laps yet',
  emptyBody: 'Your best lap time shows here once you cross the line.',
  errorTitle: 'Not saved on this device',
  errorBody: 'Lap times could not be saved on this device. You can still race, but times will not be kept after the app closes.',
};

const loading = ref(true);
lapsReady.finally(() => { loading.value = false; });
const best = computed(() => bestLap.value);

const router = useRouter();
// The lap is saved when it is finished, so leaving mid-race leaves nothing behind.
const startLap = () => router.push({ name: 'drive', params: { id: 'new' } });
const openGarage = () => router.push({ name: 'garage' });
</script>

<style scoped>
.grid-body { display: grid; gap: var(--sp-4); max-width: 560px; margin: 0 auto; }
.grid-lede { margin: 0; color: var(--dim); font-size: var(--text-md, 1rem); line-height: 1.45; }
.grid-stats { display: grid; grid-template-columns: 1fr 1fr; gap: var(--sp-3); }
</style>
